import React from 'react'
import { NavLink } from 'react-router-dom'
import './style.scss'
import { useSelector } from 'react-redux'

const Connection = () => {
    const count = useSelector((state) => state.notification)
    return (
        <div className="custom-navbar">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <NavLink
                            to="/connection/"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >Accepted {count.acceptedProposal >0 ? <span>{count.acceptedProposal}</span> : null}</NavLink>
                        <NavLink
                            to="/connection/send"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >Send</NavLink>
                        <NavLink
                            to="/connection/pending"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >Pending {count.incomingProposal >0 ? <span>{count.incomingProposal}</span> : null}</NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Connection;